import * as React from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { ButtonGroup, Button, Switch, FormControlLabel, IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { renderHelpText } from './renderHelpText';
import { useState } from 'react';

export interface TextInputFieldProps {
    id?: string,
    value?: boolean,
    label?: string,
    disabled?: boolean,
    trueText?: string,
    falseText?: string,
    helpText?: string,
    className?: string,
    style?: React.CSSProperties,
    onChange: (value: boolean) => void,
}

export const SwitchField = (props: TextInputFieldProps) => {
    const {
        id,
        value,
        label,
        trueText,
        falseText,
        helpText,
        disabled,
        className,
        style,
        onChange,
    } = props;

    const [showHelp, setShowHelp] = useState(false);

    if(trueText || falseText) {
        return (
            <ButtonGroup className={className} style={style}>

                <Button
                    id={id ? `${id}-enable-button` : undefined}
                    disabled={disabled}
                    variant={value ? "contained" : "outlined"}
                    color="info"
                    onClick={() => onChange(true)}
                >
                    {trueText}
                </Button>

                <Button
                    id={id ? `${id}-disable-button` : undefined}
                    disabled={disabled}
                    variant={value !== undefined && !value ? "contained" : "outlined"}
                    color="error"
                    onClick={() => onChange(false)}
                >
                    {falseText}
                </Button>

            </ButtonGroup>
        );
    }

    const switchComponent = (
        <Switch
            id={id ? `${id}-input` : id ?? 'switch-input'}
            color="primary"
            checked={!!value}
            onChange={_ => onChange(!value)}
            disabled={disabled}
        />
    );

    if (label) {
        return (<>
            <FormControlLabel
                className={className}
                style={style}
                control={switchComponent}
                label={helpText 
                    ? <div>{label} <IconButton size="small" onClick={() => setShowHelp(true)}><HelpIcon/></IconButton></div> 
                    : label}
            />

            {(helpText?.length &&
                <Dialog open={showHelp} onClose={() => setShowHelp(false)}>
                    <DialogTitle>{label}</DialogTitle>
                    <DialogContent>{renderHelpText(helpText)}</DialogContent>
                </Dialog>
            ) || undefined}
        </>);
    }

    return (
        <div className={className} style={style}>
            {switchComponent}
        </div>
    );
}
